<template lang="pug">
div#dashboard
  .top
    .box
      vm-row(vm-w=12)
        vm-col.padding-cont(vm-w=9)
          .cont-text
            h1.title Dashboard
            span.txt-gris.txt-16 {{ $t('strings.welcome')}}
          vm-row(vw-w=12 vm-type='flex' vm-justify='space-between')
            vm-col.card-wrapper(vm-w=6)
              CardDashboard(:number="dashboard.specialism" :userR="dashboard.specialimsWeek" :title="$t('strings.prof_counts')")
            vm-col.card-wrapper(vm-w=6)
              CardDashboard(:number="dashboard.users" :userR="dashboard.usersWeek" :title="$t('strings.users_counts')")
          vm-row(vw-w=12 vm-type='flex' vm-justify='center')
            vm-card.cont-graphis
              h2 {{ $t('strings.services_earnings')}}
              .chart
                apexchart(type="bar" height="300" width="100%" :options="chartOptions2" :series="graphic_data" v-if="!isLoading")
        vm-col(vm-w=3)
          .content-earnings
            .box-earnings
              h4 {{ $t('strings.earnings')}}
              span.numbers {{ dashboard.gananciasExpert | currency }}
              span.text-gray {{ $t('strings.earnings')}}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CardDashboard from '@/components/aditionals/CardDashboard.vue'
export default {
  name: 'Dashboard',
  components: {
    CardDashboard
  },
  data: () => {
    return {
      series: [25, 25, 50],
      chartOptions: {
        chart: {
          type: 'donut'
        }
      },
      options: {
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: '90%'
            }
          }
        },
        labels: [
          'Llamadas',
          'Mensajes',
          'Consultas'
        ],
        colors: ['#007F5F', '#2d00f7', '#001233'],
        fill: {
          type: 'solid',
          gradient: {
            shade: 'light',
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          }
        }
      },
      chartOptions2: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '40%'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 5,
          colors: ['transparent']
        },
        legend: {
          position: 'right',
          horizontalAlign: 'left'
        },
        colors: ['#2BA5C6', '#76E384'],
        xaxis: {
          categories: ['Mensajes', 'Llamadas', 'Consultas']
        },
        yaxis: {

        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return '$' + val
            }
          }
        }
      },
      ganancias: {}
    }
  },
  computed: {
    ...mapGetters([
      'dashboard'
    ]),
    graphic_data () {
      let data = [{
        name: 'Mes',
        data: [
          this.dashboard.servicesMensajesM,
          this.dashboard.servicesLLamadaM,
          this.dashboard.servicesDiaryM
        ]
      }, {
        name: 'Mes Pasado',
        data: [
          this.dashboard.servicesMensajesMP,
          this.dashboard.servicesLLamadaMP,
          this.dashboard.servicesDiaryMP
        ]
      }]
      return data
    }
  },
  async created () {
    await this.loadDashboard()
    this.series = [this.dashboard.usuariosLLamadaActivo, this.dashboard.usuariosMensajesActivo, this.dashboard.usuariosDiaryActivo]
    this.ganancias = {
      mes: {
        messajes: this.dashboard.servicesMensajesM,
        llamadas: this.dashboard.servicesLLamadaM,
        consultas: this.dashboard.servicesDiaryM
      }
    }
    this.setGraphicData({
      mes: [
        this.dashboard.servicesMensajesM,
        this.dashboard.servicesLLamadaM,
        this.dashboard.servicesDiaryM
      ],
      mesPasado: [
        this.dashboard.servicesMensajesMP,
        this.dashboard.servicesLLamadaMP,
        this.dashboard.servicesDiaryMP
      ]
    })
  },
  methods: {
    ...mapActions([
      'loadDashboard',
      'setGraphicData'
    ])
  }
}
</script>

<style lang="scss">
#dashboard {
  margin: 0px 30px;
  .title {
    font-size: 40px;
    font-weight: 600;
  }
}
.padding-cont {
  padding: 0px 30px;
}
.card-wrapper{
  padding-right: 25px;
}
.top {
  display: flex;
}
.txt-gris {
   color: gray;
 }
.txt-18{
  font-size: 18px;
}
.txt-16{
  font-size: 16px;
}
.imageBox {
  position: absolute;
  top: 30px;
  width: 20%;
  margin: 50px 70px 0px 10px;
}
.text-porcentaje {
  position: absolute;
  top: 19%;
  left: calc(91% - 110px);
  font-size: 13px;
  font-weight: 600;
}
.users {
  position: absolute;
  top: 35%;
  left: calc(41% - 70.2px);
  font-size: 18px;
  font-weight: 600;
}
.total {
  position: absolute;
  top: 45%;
  left: calc(48% - 150px);
  font-size: 40px;
  font-weight: 600;
  width: 150px;
  text-align: center;
}
.box {
  width: 100%;
  margin-top: 20px;
  .cont-text {
    height: 100px;
    margin-bottom: 20px;
  }
  .cont-graphis {
    margin: 0px 30px 0px 0px;
    height: 400px;
    padding: 10px 20px;
    .chart {
      margin-top: 10px;
      position: relative;
      max-width: 100%;
  }
  }
}
.image {
  height: 190px;
}

.bottom {
  position: absolute;
  top: 310px;
  width: 90% !important;
}
.bottomCharts{
  position: absolute;
  top: 278px;
  width: 90% !important;
  display: flex;
  align-items: center;
}
.chart2 {
  float: right;
  margin-top: 10px;
  border-radius: 15px;
  width: 42%;
}
.rightText{
  position: absolute;
  right: 539px;
}
.chartText{
  padding-left: 100px;
}
.apexcharts-legend-series{
  margin-bottom: 20px !important;
}
.apexcharts-legend.apexcharts-align-center.position-right{
    top: 34% !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-around !important;
    height: 120px !important;
    padding-right: 12%;
}
.procentajes {
  top: 30% !important;
  display: flex !important;
  position: absolute;
  flex-direction: column !important;
  justify-content: space-around !important;
  height: 120px !important;
  padding-right: 12%;
  right: -15%;
  font-weight: bold;

}
.content-earnings {
  flex-direction: row;
  justify-content: center;
  top: 30px;
  position: relative;
  padding: 0px 10px;
  border-left: .5px solid #a3a3a357;
  .cont-graphis-left {
  padding: 10px 10px;
  margin-top: 35%;
  }
  .box-earnings {
    height: 100%;
    padding: 15px;
    border-radius: 15px;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 10px 0px;
    .numbers {
      font-size: 40px;
      font-weight: 600;
      color: #000;
      }
    .footer-card {
      border-top: .5px solid #a3a3a357;
      padding: 20px 0px 0px 10px;
      .icon-person {
        background: #3AD5FF7A;
        padding: 5px;
        border-radius: 5px;
      }
    }
    .text {
      font-size: 14px;
      color: #2BA5C6;
    }
    .text-gray {
      font-size: 12px;
      color: gray;
    }
  }
  .bottom-earnings {
    .btn-earnings {
      margin: 30px 0px 30px 0px;
      font-size: 8px;
      font-weight: bold;
      color: #2ba5c6 !important;
      background: #fff !important;
      border: 1px solid #2ba5c6;
    }
    }
}
.apexcharts-legend.apexcharts-align-left.position-top{
  top: 15px !important;
}
</style>
